import axios from "axios";
import { config } from "../config";

const publicApi = axios.create({
  baseURL: config.publicApiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export default publicApi;
